import FormTemplate from "@Common/FormTemplate";
import OfferForm from "@Common/OfferForm";
import Share from "@Common/Share";
import { getSqlServerGuidHash, sendMetric, randomNumber, getWhatId, getAbTestMetrika } from "@utils";

import { inject, observer } from "mobx-react";

import dayjs from "dayjs";

import { useState, useEffect } from "react";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const Default = inject("mainStore")(
    observer(({ mainStore, modal = {}, setIsAccordionOpen }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const [open, setOpen] = useState(false);
        const [number, setNumber] = useState(5942);
        const [time, setTime] = useState("10:03");
        const [stateAnswer, setStateAnswer] = useState(0);
        const [percentNumber, setPercentNumber] = useState(10);
        const [isLarge, setIsLarge] = useState(false);

        const { offerItem } = modal;
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);

        const termsOfUse =
            offerItem && offerItem.offerDetail && offerItem.offerDetail?.termsOfUse
                ? offerItem.offerDetail?.termsOfUse.replace(/{{dateEnd}}/gim, dayjs(offerItem.dateEnd).format("DD.MM.YYYY")).replace(/{{dateStart}}/gim, dayjs(offerItem.dateStart).format("DD.MM.YYYY"))
                : "";

        useEffect(() => {
            const elem = document.getElementById("modal-container");
            if (elem) {
                const clientHeight = elem.clientHeight + 136; // 136 margin
                const windowHeight = window.innerHeight;

                if (clientHeight > windowHeight) {
                    const modal = document.querySelector(".modal.show-modal.offer"); //для скрола модального окна оффера за границы экрана
                    modal.classList.add("offer_disable-center");

                    setIsLarge(true);
                }
            }

            if (localStorage.getItem(offerItem._id)) {
                setNumber(parseInt(localStorage.getItem(offerItem._id)));
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);
            } else {
                let num = randomNumber(5000, 25000);
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);

                localStorage.setItem(offerItem._id, num);
                setNumber(num);
            }
        }, []);

        useEffect(() => {
            let interval = setInterval(() => {
                let num = randomNumber(1, 10);
                localStorage.setItem(offerItem._id, number + num);
                setNumber(number + num);
            }, 10000);
            return () => {
                clearInterval(interval);
            };
        }, [number]);

        const handleOpen = () => {
            setOpen(!open);

            if (!open) {
                sendMetric("click_offer_details", {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            } else {
                sendMetric("click_offer_details_close", {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            }

            const modal = document.querySelector(".modal.show-modal.offer");
            if (!isLarge) modal.classList.toggle("offer_disable-center");
        };

        return (
            <div className="offers">
                <div className="content">
                    <div className={`content__img`}>
                        <img src={offerItem.cover || offerItem.vendor?.logoList || ""} />
                        <Share offer={offerItem} mobile={false} />
                    </div>
                    <span className="content__date">Обновлен {dayjs().format("DD.MM.YY")}</span>

                    <div className="content__title" dangerouslySetInnerHTML={{ __html: offerItem.title }}></div>
                    {/* <div className={`content__desc `}>
                        Сегодня это предложение забрали{" "}
                        <span>
                            {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                        </span>
                    </div> */}
                </div>

                {offerItem.formTemplate && stateAnswer < offerItem.formTemplate?.length ? (
                    <div className="block__form">
                        {offerItem.formTemplate?.map((el, index) =>
                            stateAnswer === index ? (
                                <FormTemplate
                                    type={el.restrictionType}
                                    item={el}
                                    key={index}
                                    stateAnswer={stateAnswer}
                                    setStateAnswer={setStateAnswer}
                                    formTemplate={offerItem.formTemplate}
                                    offerId={offerItem._id}
                                    vendorId={offerItem.vendor._id}
                                    surveyId={offerItem.surveyId}
                                    index={index}
                                    promo={offerItem}
                                    setIsAccordionOpen={setIsAccordionOpen}
                                    setPercentNumber={setPercentNumber}
                                    percentNumber={percentNumber}
                                    number={number}
                                    time={time}
                                />
                            ) : null,
                        )}
                    </div>
                ) : (
                    <OfferForm offerItem={offerItem} percentNumber={percentNumber} setPercentNumber={setPercentNumber} number={number} time={time} />
                )}
                {offerItem.ghostOffer ? null : <div className="offers__description" dangerouslySetInnerHTML={{ __html: offerItem.description }}></div>}

                {offerItem.ghostOffer ? null : (
                    <div className="offers__details_btn cursor" onClick={() => handleOpen()}>
                        {open ? "Скрыть" : "Подробное описание"}
                    </div>
                )}

                {offerItem.ghostOffer ? null : <div className={`offers__info ${open ? "open" : ""}`} dangerouslySetInnerHTML={{ __html: offerItem?.offerDetail?.howToActivate || "" }}></div>}
                {offerItem.ghostOffer ? null : (
                    <div className={`offers__terms ${open ? "open" : ""}`}>
                        <div className="container__all-сonditions_text" dangerouslySetInnerHTML={{ __html: termsOfUse }}></div>
                    </div>
                )}
            </div>
        );
    }),
);

export default Default;
